import { render, staticRenderFns } from "./faq-1.vue?vue&type=template&id=ceba6742"
import script from "./faq-1.vue?vue&type=script&lang=js"
export * from "./faq-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports